import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import Header from '../../../components/Header'
import { tokens } from "../../../theme";
import { useSelector } from 'react-redux';

const EventDef = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { branch_name, _id } = useSelector((state) => {
      return state.posts.data;
    });


    return (
        <Box m="20px" >
   
          <Header title="Event Definations" subtitle="Create and define your events" />
          <Header title={branch_name} subtitle={_id} />
   
    
        </Box>
      )
}

export default EventDef